<template>
  <div class="date-dropdown-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <div
        class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
      >
        <div class="vs-con-input">
          <label
            v-if="label || required"
            :for="`input-${name}`"
            class="vs-input--label"
            >{{ label }}
            <span v-if="required" class="text-danger"
              ><feather-icon icon="star-of-life"/></span
          ></label>
          <select
            :id="name + '-month'"
            v-model="month"
            :name="name + '-month'"
            class="date-dropdown"
            @change="dateChange"
          >
            <option value="00">00</option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="04">04</option>
            <option value="05">05</option>
            <option value="06">06</option>
            <option value="07">07</option>
            <option value="08">08</option>
            <option value="09">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
          <select
            :id="name + '-year'"
            v-model="year"
            required
            :name="name + '-year'"
            class="date-dropdown"
            @change="dateChange"
          >
            <option :value="null">-- Jahr --</option>
            <option v-for="year in years" :key="year" :value="year">{{
              year
            }}</option>
          </select>
        </div>
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
// import moment from "moment";

export default {
  props: {
    value: { type: [String, Number, Object, Date], default: null },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, default: null },
    required: { type: Boolean, default: false }
  },
  data: () => ({
    year: "",
    month: ""
  }),
  computed: {
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1960 },
        (value, index) => 1961 + index + 1
      );
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function() {
        if (this.value) {
          let parts = this.value.split("-");
          this.month = parts[1];
          this.year = parts[0];
        } else {
          this.month = "00";
          this.year = null;
        }
      }
    }
  },
  methods: {
    dateChange() {
      let date = "";
      date = this.year + "-" + this.month + "-01";
      this.$emit("input", date);
    }
  }
};
</script>
